/**
 * ★ [owner, 21/09/2026] A recusa do Modo Agente por FUNCIONALIDADE, lembrada
 * pela SESSÃO da aba (`sessionStorage`), por escritório.
 *
 * Até aqui a degradação para o Modo Chat era só um `data()` da tela: cada F5
 * voltava a tentar `POST /runs`, tomava o 403 de novo e repetia o aviso
 * "Os recursos de agente não estão liberados…" a cada primeira mensagem.
 * `sessionStorage`, e NUNCA `localStorage`: morre com a aba, então uma
 * funcionalidade contratada no meio do caminho volta a ser perguntada ao
 * backend na próxima aba, sem estado velho preso no navegador. Sem
 * escritório (sessão ainda sem usuário) não há o que lembrar. `try/catch`
 * nos dois sentidos: storage bloqueado nunca derruba o chat.
 */
const PREFIXO = 'iaModoAgenteRecusado:v1:'

function chave(idEscritorio) {
  return PREFIXO + String(idEscritorio)
}

/** O backend já recusou o Modo Agente para este escritório nesta aba? */
export function lerRecusaDaSessao(idEscritorio) {
  if (!idEscritorio) return false
  try {
    return globalThis.sessionStorage.getItem(chave(idEscritorio)) === '1'
  } catch (erro) {
    return false
  }
}

export function gravarRecusaDaSessao(idEscritorio) {
  if (!idEscritorio) return
  try {
    globalThis.sessionStorage.setItem(chave(idEscritorio), '1')
  } catch (erro) {
    // Storage indisponível: a tela continua degradada pelo `data()` de sempre.
  }
}
